/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxfReportsV1ReportEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXF_REPORTS_V1_REPORT_EVENT_ENTITY_NAME = 'ixf.reports.v1.ReportEvent';
export const ixfReportsV1ReportEventEntity = new schema.Entity<IxfReportsV1ReportEvent>(IXF_REPORTS_V1_REPORT_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxfReportsV1ReportEvent) => `${entity.metadata?.eventId}` });

